/**
 * @packageDocumentation
 * @module dom/query
 */

export type TQueryMain = string;

/**
 * { @link TQueryMain }
 */
export default 'main, [role="main"]';
